document.addEventListener("turbo:load", function () {
  let companyField = document.querySelector("#event_booking_company");
  let publicEntityHintElm = document.body.querySelector('#public_entity_hint');
  let publicEntities = ["Bundes", "Bundesbank", "Bundesamt", "Bundesverwaltungsamt", "ITZBund"];
  if (!companyField || !publicEntityHintElm) return;

  function update() {
    let companyIsPublicEntity = publicEntities.some(v => companyField.value.toLowerCase().includes(v.toLowerCase()));
    if (companyIsPublicEntity) {
      publicEntityHintElm.style.display = 'block';
      let invoiceDetailsCollapse = new window.bootstrap.Collapse(document.getElementById('collapseInvoiceDetails'), {
        toggle: false
      });
      invoiceDetailsCollapse.show();
    } else {
      publicEntityHintElm.style.display = 'none';
    }
  }

  companyField.addEventListener("change", () => {
    update();
  });
  setTimeout(() => update(), 0);
});
